<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-header" />
          <h5 class="d-inline ml-2">Holidays</h5>
          <div class="card-header-actions">
            <CButton color="primary" @click="$store.state.holidayItemAsideShow = true">
              <CIcon name="cil-plus" class="align-bottom" /><strong>Add New</strong> Holiday
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Holidays",
  components: {
    BackendTable,
  },
};
</script>
